import { DataType } from "../../../tables"
import { Vehicle } from "../state/types"
import { useFiltersHooks } from "../../../features/ui"
import { normalize } from "../../../utils/typeUtils"
import { useDataTypesHooks } from "../../../features/data-types"
import { useRoadmapLoaders } from "../loaders/roadmapLoaders"

export const useVehicleHooks = () => {
    const { formatPlate } = useDataTypesHooks()
    const { search2 } = useFiltersHooks()

    const roadmapLoaders = useRoadmapLoaders()

    const describeVehicle = (vehicle: Vehicle): string => {
        return `${vehicle.name} (${formatPlate(vehicle.plate)})`
    }

    const canRemoveVehicle = async (vehicleId: string): Promise<boolean> => {
        const { countRoadmaps } = roadmapLoaders()
        const roadmapsCount = await countRoadmaps('vehicleId', vehicleId)
        return roadmapsCount === 0
    }

    const searchVehicles = (
        vehicles: Vehicle[],
        searchText = ''
    ): Promise<Vehicle[]> => {
        const valuesFn = async (vehicleDT: DataType) => {
            const { name, plate } = vehicleDT as Vehicle
            return [
                normalize(name),
                normalize(plate)
            ]
        }
        const sortFn = (vehicleDT_A: DataType, vehicleDT_B: DataType) =>
            (vehicleDT_A as Vehicle).name.localeCompare((vehicleDT_B as Vehicle).name)

        return search2(vehicles, searchText, valuesFn, undefined, sortFn) as Promise<Vehicle[]>
    }

    return {
        describeVehicle,
        canRemoveVehicle,
        searchVehicles
    }
}
